import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { RankData, QueryRankData, RankInfo, typeToKey, typeToPrefix } from "../contexts/ranking";

export const useRank = () => {
  const [info, setInfo] = useState<RankInfo | null>(null);

  const { data, isLoading } = useQuery<RankData>({
    queryKey: ["rank", info?.type, info?.id],
    queryFn: async () => {
      const resp = await fetch(`/api/${info?.type === "team" ? "teams" : "functions"}/${info?.id}`);
      const data = resp.json();
      return data;
    },
    enabled: info !== null
  });

  const toLabel = () =>
    info
      ? `${typeToPrefix[info.type]} ${data?.[typeToKey[info.type] as keyof RankData]}`
      : "Nothing selected";

  const returnData = (): QueryRankData | undefined => {
    if (!info) {
      return;
    }
    return {
      data,
      isLoading,
      ...info,
      toLabel
    };
  };

  return { setInfo, data, isLoading, ...info, returnData, toLabel };
};
